import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import PublicPortal from './pages/PublicPortal';
import PublicTenderDetail from './pages/PublicTenderDetail';
import LoginRoute from './pages/LoginRoute';
import PublicationPolicy from './pages/PublicationPolicy';
import VendorRegister from './pages/VendorRegister';
import VendorDashboard from './pages/VendorDashboard';
import VendorTenders from './pages/VendorTenders';
import VendorProfile from './pages/VendorProfile';
import VendorBids from './pages/VendorBids';
import SubmitBid from './pages/SubmitBid';
import BidConfirmation from './pages/BidConfirmation';
import OfficerDashboard from './pages/OfficerDashboard';
import ManageTenders from './pages/ManageTenders';
import CreateTender from './pages/CreateTender';
import EditTender from './pages/EditTender';
import BidOpeningList from './pages/BidOpeningList';
import BidOpening from './pages/BidOpening';
import EvaluationList from './pages/EvaluationList';
import EvaluationWorkspace from './pages/EvaluationWorkspace';
import ContractAwardList from './pages/ContractAwardList';
import ContractAward from './pages/ContractAward';
import AuditLogs from './pages/AuditLogs';
import Reports from './pages/Reports';
import AdminConsole from './pages/AdminConsole';

function RoleHome() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/portal" replace />;
  if (user.role === 'VENDOR') return <Navigate to="/vendor" replace />;
  if (user.role === 'ADMIN') return <Navigate to="/admin" replace />;
  if (user.role === 'MDA_OFFICER') return <Navigate to="/officer" replace />;
  if (user.role === 'EVALUATOR') return <Navigate to="/officer/evaluation" replace />;
  if (user.role === 'AUDITOR') return <Navigate to="/officer/audit" replace />;
  return <Navigate to="/portal" replace />;
}

export default function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/portal" element={<PublicPortal />} />
      <Route path="/portal/tenders/:id" element={<PublicTenderDetail />} />
      {/* Cited by every OCDS package as its publicationPolicy: keep this address. */}
      <Route path="/open-data/publication-policy" element={<PublicationPolicy />} />
      <Route path="/login" element={<LoginRoute />} />
      <Route path="/register" element={<VendorRegister />} />

      {/* Vendor */}
      <Route path="/vendor" element={<ProtectedRoute roles={['VENDOR']}><VendorDashboard /></ProtectedRoute>} />
      <Route path="/vendor/tenders" element={<ProtectedRoute roles={['VENDOR']}><VendorTenders /></ProtectedRoute>} />
      <Route path="/vendor/profile" element={<ProtectedRoute roles={['VENDOR']}><VendorProfile /></ProtectedRoute>} />
      <Route path="/vendor/bids" element={<ProtectedRoute roles={['VENDOR']}><VendorBids /></ProtectedRoute>} />
      <Route path="/vendor/tenders/:tenderId/bid" element={<ProtectedRoute roles={['VENDOR']}><SubmitBid /></ProtectedRoute>} />
      <Route path="/vendor/bids/confirmation" element={<ProtectedRoute roles={['VENDOR']}><BidConfirmation /></ProtectedRoute>} />

      {/* Officer */}
      <Route path="/officer" element={<ProtectedRoute roles={['MDA_OFFICER']}><OfficerDashboard /></ProtectedRoute>} />
      <Route path="/officer/tenders" element={<ProtectedRoute roles={['MDA_OFFICER']}><ManageTenders /></ProtectedRoute>} />
      <Route path="/officer/tenders/new" element={<ProtectedRoute roles={['MDA_OFFICER']}><CreateTender /></ProtectedRoute>} />
      <Route path="/officer/tenders/:id/edit" element={<ProtectedRoute roles={['MDA_OFFICER']}><EditTender /></ProtectedRoute>} />
      <Route path="/officer/bid-opening" element={<ProtectedRoute roles={['MDA_OFFICER']}><BidOpeningList /></ProtectedRoute>} />
      <Route path="/officer/bid-opening/:tenderId" element={<ProtectedRoute roles={['MDA_OFFICER']}><BidOpening /></ProtectedRoute>} />
      <Route path="/officer/evaluation" element={<ProtectedRoute roles={['MDA_OFFICER', 'EVALUATOR']}><EvaluationList /></ProtectedRoute>} />
      <Route path="/officer/evaluation/:tenderId" element={<ProtectedRoute roles={['MDA_OFFICER', 'EVALUATOR']}><EvaluationWorkspace /></ProtectedRoute>} />
      <Route path="/officer/award" element={<ProtectedRoute roles={['MDA_OFFICER']}><ContractAwardList /></ProtectedRoute>} />
      <Route path="/officer/award/:tenderId" element={<ProtectedRoute roles={['MDA_OFFICER']}><ContractAward /></ProtectedRoute>} />
      <Route path="/officer/audit" element={<ProtectedRoute roles={['ADMIN', 'AUDITOR']}><AuditLogs /></ProtectedRoute>} />
      <Route path="/officer/reports" element={<ProtectedRoute roles={['MDA_OFFICER', 'ADMIN', 'AUDITOR']}><Reports /></ProtectedRoute>} />

      {/* Admin */}
      <Route path="/admin" element={<ProtectedRoute roles={['ADMIN']}><AdminConsole /></ProtectedRoute>} />

      {/* Home dispatch */}
      <Route path="/" element={<RoleHome />} />
      <Route path="*" element={<Navigate to="/portal" replace />} />
    </Routes>
  );
}
